module.exports = __webpack_public_path__ + "static/media/Badge.fe13f739.svg";